'use client';

import { useEffect } from 'react';
import useAnalytics from '@/hooks/useAnalytics';
import type { PageLoadFact } from '@/analytics/models/cventAnalytics/PageLoadFact';
import type { BaseFactDetails } from '@/analytics/models/cventAnalytics/BaseFact';
import { getPageUrl } from '@/utils/analyticsClientHelper';
import useMap from '@/hooks/useMap';
import type { SearchParams } from '@/models/SearchParams';

function LogPageLoadEnd({
  searchTerm,
  referrerHeader,
  searchParams
}: {
  searchTerm: string;
  referrerHeader: string;
  searchParams: SearchParams;
}) {
  const analytics = useAnalytics();
  const map = useMap();

  useEffect(() => {
    if (analytics.baseProperties !== ({} as BaseFactDetails)) {
      analytics.reportFact<PageLoadFact>(
        {
          type: 'csn_search_page_load',
          event: 'end',
          page_url: getPageUrl(),
          map_view: map.mapExpanded ? 'EXPANDED' : 'COLLAPSED',
          search_term: searchTerm,
          referrer: referrerHeader,
          page: 'search_results'
        },
        performance.timing.loadEventEnd
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analytics, searchParams]);

  return <></>;
}

export default LogPageLoadEnd;
